// extracted by mini-css-extract-plugin
export default {"nameInput":"EpicForm_nameInput__VlHP9","nameInputTooltipIcon":"EpicForm_nameInputTooltipIcon__U-ida","descriptionInput":"EpicForm_descriptionInput__Tvz8M"};